export const environment = {
    firebase: {
        apiKey: 'AIzaSyAVhpGuNIUaLq0K9CXJXraFP3lqxVb2tMA',
        authDomain: 'anima-en-74854.firebaseapp.com',
        projectId: 'anima-en-74854',
        storageBucket: 'anima-en-74854.appspot.com',
        messagingSenderId: '531971633300',
        appId: '1:531971633300:web:a44ec367d5bcb5aebb4481',
        measurementId: 'G-47DCSNXV23'
    },
    appVersion: require('../../../../package.json').version,
    // paypalId: 'AZOlmXhW1-5fC4A1BMatBuJJxcpkNvWF_V68L98v3tQGcwtjMtj9jOxlhtP5DktauEZ6WI2HG2P6QQUl',
    paypalId: 'ASgtjFrQt3uCwx7eTod02SLeizJkwgApotCQymMoS2PYMA0l-io-2NDtOBBUnxlkgiI1dQIwOrX9BFQq',
    production: true,
    isProd: true,
    cookieDomain: 'anima.help',
    googleClientId: '1082322181123-7rmg57kpndgiutfmetl6alaaljkbv9tu.apps.googleusercontent.com',
    googleTagId: 'GTM-TGQ3FF3',
    facebookClientId: '1',
    defaultLanguage: 'en',
    availableLanguages: ['en', 'es'],
    apiUrl: '/api',
    // paypal: 'https://pay-sandbox.anima.help',
    paypal: 'https://pay.anima.help',
    notify: 'https://notify.anima.help',
    // aiUrl: 'https://chat-bot-972423687157.us-central1.run.app',
    aiUrl: 'https://chat-bot-531971633300.us-central1.run.app',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
